import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { w3cwebsocket as W3CWebSocket } from "websocket";
import { getWebsocketUrl } from "@/utils/websocket-url";
var listeners = new Map();
var intentionalClose = false;
var reconnectTimer = null;
var activePath = "";
var dispatch = function dispatch(message) {
  var handlers = listeners.get(message.action);
  if (!handlers) return;
  handlers.forEach(function (handler) {
    return handler(message);
  });
};

/** Transport store: owns the single worklist WebSocket and a pub/sub registry. */
export var useWorklistSocketStore = create()(devtools(function (set, get) {
  return {
    status: "idle",
    socket: null,
    connect: function connect(path) {
      if (typeof window === "undefined") return;
      if (get().socket && get().status === "open" && activePath === path) {
        return;
      }
      activePath = path;
      intentionalClose = false;
      set({
        status: "connecting"
      }, false, "connect/start");
      var ws = new W3CWebSocket(getWebsocketUrl() + path);
      ws.onopen = function () {
        return set({
          status: "open",
          socket: ws
        }, false, "connect/open");
      };
      ws.onerror = function () {
        set({
          status: "closed"
        }, false, "connect/error");
        ws.close();
      };
      ws.onmessage = function (event) {
        if (typeof event.data !== "string") return;
        try {
          dispatch(JSON.parse(event.data));
        } catch (_unused) {
          return;
        }
      };
      ws.onclose = function () {
        set({
          status: "closed",
          socket: null
        }, false, "connect/close");
        if (intentionalClose) return;
        if (reconnectTimer) clearTimeout(reconnectTimer);
        reconnectTimer = setTimeout(function () {
          return get().connect(activePath);
        }, 5000);
      };
    },
    disconnect: function disconnect() {
      intentionalClose = true;
      if (reconnectTimer) clearTimeout(reconnectTimer);
      var ws = get().socket;
      if (ws && ws.readyState === ws.OPEN) ws.close();
      set({
        status: "closed",
        socket: null
      }, false, "disconnect");
    },
    addListener: function addListener(action, handler) {
      var _listeners$get;
      var handlerSet = (_listeners$get = listeners.get(action)) !== null && _listeners$get !== void 0 ? _listeners$get : new Set();
      handlerSet.add(handler);
      listeners.set(action, handlerSet);
    },
    removeListener: function removeListener(action, handler) {
      var _listeners$get2;
      (_listeners$get2 = listeners.get(action)) === null || _listeners$get2 === void 0 || _listeners$get2["delete"](handler);
    },
    send: function send(action, params) {
      var ws = get().socket;
      if (ws && ws.readyState === ws.OPEN) {
        ws.send(JSON.stringify({
          action: action,
          params: params
        }));
      }
    }
  };
}, {
  name: "WorklistSocketStore",
  enabled: typeof window !== "undefined" && process.env.NODE_ENV !== "production"
}));